// extracted by mini-css-extract-plugin
export default {"qrpreview":"styles__qrpreview__uu8Hz"};